<template>
  <div id="page-dashboard">

    <!--Stats cards-->
    <loader v-if="loader"/> 
    <div class="row">
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <!---->
          <!---->
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center icon-success">
                    <i class="ti-wallet"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p>Today's Sale</p>
                    {{ today_sale.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div>
                <hr>
                <div class="stats">
                  <i class="ti-calendar"></i> Go to Reports
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <!---->
          <!---->
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center icon-info">
                    <i class="ti-user"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p>Clients</p>
                    {{ total_client.toLocaleString() }}
                  </div>
                </div>
              </div>
              <div>
                <hr>
                <div class="stats">
                  <i class="ti-reload"></i> Updated now
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
      <div class="col-md-6 col-xl-3">
        <div class="card">
          <!---->
          <!---->
          <div class="card-body">
            <div>
              <div class="row">
                <div class="col-5">
                  <div class="icon-big text-center icon-info">
                    <i class="ti-pencil"></i>
                  </div>
                </div>
                <div class="col-7">
                  <div class="numbers">
                    <p>Current Branch: </p>
                    <p><strong>{{ currentBranchName }}</strong></p>
                  </div>
                </div>
              </div>
              <div>
                <div style="text-align: center; margin-bottom: 13px;">
                    <p-button type="info" round @click.native.prevent="changeBranch" id="change-branch">
                      Change Branch
                    </p-button>  
                </div>
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
    </div>

    <!--Charts-->
       <card title="Today's Appointment">
        <div slot="raw-content" class="table-responsive">
          <table class="table table-striped" id="appoint-tbl">
          <thead> 
              <th>Time</th>
              <th>Name</th>
              <th>Services</th>
              <th>Branch</th>
          </thead>
            <tbody v-if="appointments.total > 0">
                                              <tr v-for="(appointment,index) in appointments.data" :key="index">
                                                  <td>{{ appointment.time }} {{ appointment.first_name }}</td>
                                                  <td>{{ appointment.last_name }}</td>
                                                  <td>{{ appointment.formated_service }}</td>
                                                  <td>{{ appointment.branch_id === 1 ? 'Gaerlan' : appointment.branch_id === 2 ? 'Dolores' : 'Unknown' }}</td>
                                              </tr>
            </tbody>
                                          <tbody v-else>
                                              <tr>
                                                  <td align="center" colspan="4" id="no-record">No Appointment.</td>
                                              </tr>
            </tbody>
   </table>
       <!-- Branch Select Modal -->
    <Modal :showModal="branchModalVisible" title="Select Branch" @close="closeBranchModal">
      <loader v-if="loader_branch"/> 

      <div>
        <label for="branch">Choose Branch:</label>
        <select v-model="selectedBranch" id="branch" class="form-control">
          <option v-for="branch in branches" :key="branch.id" :value="branch.id">
            {{ branch.name }}
          </option>
        </select>
      </div>

      <div class="mt-3 text-right">
        <p-button type="info" round @click.native.prevent="confirmBranch">
          Confirm
        </p-button>
      </div>
    </Modal>
        </div>
      </card>

      

  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
import Loader from "@/components/Loader";
import axios from 'axios'
import api  from "@/static/config.json";
import Modal from '@/components/Modal';
export default {
  components: {
    StatsCard,
    ChartCard,
    Modal,
    Loader
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
      statsCards: [

        {
          type: "success",
          icon: "ti-wallet",
          title: "Revenue",
          value: "PHP 0",
          footerText: "Last day",
          footerIcon: "ti-calendar",
        },
        {
          type: "info",
          icon: "ti-user",
          title: "Clients",
          value: "+45",
          footerText: "Updated now",
          footerIcon: "ti-reload",
        },
      ],
      activityChart: {
        data: {
          labels: ["1/20/2024", "1/21/2024", "1/23/2024"],
          series: [[1, 32, 100],[1, 32, 100],[1, 32, 100]]
        },
        options: {
          seriesBarDistance: 10,
          axisX: {
            showGrid: false,
          },
          height: "245px",
        },
      },
      preferencesChart: {
        data: {
          labels: ["62%", "32%", "6%"],
          series: [62, 32, 6],
        },
        options: {},
      },
      today_sale:0,
      total_client:0,
      appointments:[],
      loader:false,
      branchModalVisible: false,
      loader_branch: false,
      branches: [
        { id: 1, name: "Gaerlan" },
        { id: 2, name: "Dolores" },
      ],
      selectedBranch: null,
      currentBranchId: null,
    };
  },
  methods:{
        getReport() {
          this.loader = true;
          const token = localStorage.getItem('token');
          const branch_id = localStorage.getItem('branch_id'); // 👈 get branch_id from localStorage

          axios.get(api.API_URL + `/report/dashboard`, {
            headers: { 
              Authorization: `Bearer ${token}` 
            },
            params: { // 👈 send branch_id as query param
              branch_id: branch_id
            }
          })
          .then(({ data }) => {
            this.loader = false;
            this.today_sale = data.today_sale;
            this.total_client = data.total_client;
            this.activityChart.data.labels = data.labels;
            this.activityChart.data.series = data.series;
            this.$chartist;
          })
          .catch(({ response }) => {
            if (response.data.error.code == 'token_could_not_verified') {
              this.$router.push('/login');
            }
          });
        },
        async getAppointment(){
                  let self = this
                  let date = this.getDate();
                  await axios.get(api.API_URL+`/appointment?limit=20&from=${date}&to=${date}`,
                  {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
                  }
                ).then(({data})=>{
                  self.loader = false;
                  self.appointments = data
                  self.total_page = Math.ceil(data.total/limit);

                }).catch(({ response })=>{
                  if(response.data.error.code =='token_could_not_verified'){
                              localStorage.removeItem("token");
                              this.$router.push('/login')
                  }
                })

                  
        },getDate(){
            const today = new Date();
            const yyyy = today.getFullYear();
            let mm = today.getMonth() + 1; // Months start at 0!
            let dd = today.getDate();

            if (dd < 10) dd = '0' + dd;
            if (mm < 10) mm = '0' + mm;

            const formattedToday = mm + '/' + dd + '/' + yyyy;
            return formattedToday;
        },
         closeBranchModal() {
          this.branchModalVisible = false;
        },
        confirmBranch() {
          if (this.selectedBranch) {
            localStorage.setItem("branch_id", this.selectedBranch);
            this.currentBranchId = this.selectedBranch;
            this.getReport();
            this.closeBranchModal();
          } else {
            alert("Please select a branch first.");
          }
        },
        changeBranch() {
          this.branchModalVisible = true;
        }
  },
  created(){
      this.branchModalVisible = false;
      const savedBranch = localStorage.getItem("branch_id");
      if (!savedBranch) {
        this.branchModalVisible = true;
      } else {
        this.selectedBranch = savedBranch;
        this.currentBranchId = savedBranch; // ✅ make it reactive
      }
  },
  computed: {
    currentBranchName() {
      const branch = this.branches.find(b => b.id == this.currentBranchId);
      return branch ? branch.name : "No Branch Selected";
    }
  },
  mounted(){
      this.getReport()
      this.getAppointment()
  }
};
</script>
<style></style>
